// import less file
import '../../less/includes/inline_answer_editor.less';

export function initInlineAnswerEditor() {
    if (!window.auth || !window.auth.hasOwnProperty('edit_all_module_data_anytime') || !window.auth.edit_all_module_data_anytime) {
        return;
    }

    const editableElements = document.querySelectorAll(
        '[data-editable-submission_id][data-editable-question_slug]'
    );

    editableElements.forEach(el => {
        el.classList.add('inline-answer-editor');

        el.onclick = function () {
            if (window.site !== 'icoraf') {
                return;
            }

            // We don't want two inline answer editors to be opened at the same time
            if (document.querySelector('#inline-answer-editor-wrapper')) {
                return;
            }

            if (el.classList.contains('loading')) {
                return;
            }

            const questionSlug = el.getAttribute('data-editable-question_slug')
            const submissionId = el.getAttribute('data-editable-submission_id')

            if (!questionSlug || !submissionId) {
                console.error('Missing data-editable-question_slug or data-editable-submission_id attribute');
                return;
            }

            const successIcon = el.querySelector('.success-icon');
            if (successIcon) {
                successIcon.remove();
            }

            const body = document.querySelector('body');
            const vueAppContainerWrapper = document.createElement('div');
            vueAppContainerWrapper.id = 'inline-answer-editor-wrapper';
            const vueAppContainer = document.createElement('div');
            body.appendChild(vueAppContainerWrapper);
            vueAppContainerWrapper.appendChild(vueAppContainer);

            // Bilingual answers render as sibling .en-only/.fr-only spans inside the
            // editable element; edit the one the visitor is actually reading.
            const language = document.documentElement.lang === 'en' ? 'en' : 'fr';
            const languageEl = el.querySelector(':scope .' + language + '-only');

            mountVueApp("Vue/Applications/InlineAnswerEditor/InlineAnswerEditor.vue", vueAppContainer, {
                onClose:      close,
                onSave:       promise => save(el, promise),
                answer:       (languageEl ?? el).innerHTML,
                questionSlug: questionSlug,
                submissionId: submissionId,
                language:     language,
                row:          el.getAttribute('data-editable-row'),
            });
        }
    });

    // Run infogram enhancements on page load
    enhanceInfogramIframes();
}

function close() {
    const vueAppContainerWrapper = document.querySelector('#inline-answer-editor-wrapper');
    if (vueAppContainerWrapper) {
        vueAppContainerWrapper.remove();
    }
}

function save(el, promise) {
    // Add loading class and the spinner
    el.classList.add('loading');
    const spinner = document.createElement('div');
    spinner.classList.add('fa', 'fa-spinner', 'fa-spin');
    const spinnerWrapper = document.createElement('div');
    spinnerWrapper.classList.add('spinner-wrapper');
    spinnerWrapper.appendChild(spinner);
    el.prepend(spinnerWrapper);

    promise.then((response) => {
        // Update el's submissionId and innerHTML (only the visible language's span
        // when the answer is bilingual — the other language was not edited)
        const language = document.documentElement.lang === 'en' ? 'en' : 'fr';
        const languageEl = el.querySelector(':scope .' + language + '-only');
        (languageEl ?? el).innerHTML = response.data.newValue;
        const elementsWithSameSubmissionId = document.querySelectorAll(`[data-editable-submission_id="${el.getAttribute('data-editable-submission_id')}"]`);
        elementsWithSameSubmissionId.forEach((element) => {
            element.setAttribute('data-editable-submission_id', response.data.submissionId);
        });
        el.setAttribute('data-editable-submission_id', response.data.submissionId);

        const successIcon = document.createElement('i');
        successIcon.classList.add('fa', 'fa-check', 'success-icon');
        el.prepend(successIcon);
        $(successIcon).fadeOut(3000, function () {
            successIcon.remove();
        });
    }).catch((error) => {
        console.error(error);
    }).finally(() => {
        // Remove loading class and the spinner
        el.classList.remove('loading');
        const spinnerWrapper = el.querySelector('.spinner-wrapper');
        if (spinnerWrapper) {
            spinnerWrapper.remove();
        }
    });

    close();
}


function enhanceInfogramIframes() {
    document.querySelectorAll('.infogram-container').forEach(el=> {
        if (!el.classList.contains('inline-answer-editor')) {
            el.classList.add('inline-answer-editor');

            // Add clickable overlay that links to edit page
            const overlay = document.createElement('div');
            overlay.classList.add(['inline-answer-editor']);
            overlay.style.position = 'absolute';
            overlay.style.top = '0';
            overlay.style.left = '0';
            overlay.style.height = '0';
            overlay.style.width = '0';
            overlay.style.cursor = 'pointer';
            overlay.style.zIndex = '10000';

            const editUrl = el.getAttribute('data-infogram-edit-url') ?? null;

            // Extract embedId from iframe.src
            if (editUrl) {
                el.onclick = () => {
                    window.open(editUrl, '_blank');
                };

                overlay.classList.add('infogram-click-overlay');
                el.style.position = 'relative';
                el.appendChild(overlay);
            }
        }
    });
}
